export default class OrderPaymentGeneral {
  constructor($scope, OrderService, OrderSidebarService) {
    $scope.update_order = function() {
      $scope.updating_order = true;
      $scope.form_error = '';
      OrderService.save($scope.order).then(function(data) {
        if (!data.success)
          $scope.form_error = data.message;
        $scope.updating_order = false;
        OrderSidebarService.set_payment_general_data(data.payment_general_percentage);
      });
    };

    $scope.init = function() {
      $scope.order = window.order;
      $scope.payment_statuses = window.payment_statuses;
    };

    $scope.init();
  }
}

OrderPaymentGeneral.$inject = ['$scope', 'OrderService', 'OrderSidebarService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-payment-general.ctrl.js